/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientInviteLogDto } from '../../models/client-invite-log-dto';
import { ClientInviteWorkspaceUserDto } from '../../models/client-invite-workspace-user-dto';

export interface ClientWorkspaceInviteLogControlllerInviteUser$Params {

/**
 * 고객사 ID
 */
  id: string;
      body: ClientInviteWorkspaceUserDto
}

export function clientWorkspaceInviteLogControlllerInviteUser(http: HttpClient, rootUrl: string, params: ClientWorkspaceInviteLogControlllerInviteUser$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientInviteLogDto>> {
  const rb = new RequestBuilder(rootUrl, clientWorkspaceInviteLogControlllerInviteUser.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientInviteLogDto>;
    })
  );
}

clientWorkspaceInviteLogControlllerInviteUser.PATH = '/api/clientWorkspaceInviteLog/{id}/invite';
